<div class="program-content">
  <div class="mat-display-2">
    <div class="container">
      <ul>
        <li
          *ngFor="let year of years"
          (click)="selectData(year)"
          [class.active]="year === selectedYear">
          <div class="year-card">
            {{ year }}
          </div>
        </li>
      </ul>
    </div>
  </div>
  <router-outlet/>
</div>
